import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/TextField": TextField } } });
export default ClientProvider;
